/**
 * Google Site Verification 配置
 * 用于管理不同站点的 Google 站点验证代码
 */

export interface GoogleVerificationConfig {
  code: string;
}

export const googleSiteVerificationConfig: Record<string, GoogleVerificationConfig> = {
  '.nl': {
    code: 'vissa9u2ZoLjOGXAoxanW7w6VB2gkEt4WW2IYc8X9RM',
  },
  '.de': {
    code: 'scRqfWpBlzON6l5nYLkNSPrVhyRg0ilxz0-5vxGBIlM',
  },
  '.fr': {
    code: 'AtX3rL4jVtQeL1WlK2UBJ_iUSRShqEgZJl4a2DyiBdo',
  },
  '.com': {
    code: 'AtX3rL4jVtQeL1WlK2UBJ_iUSRShqEgZJl4a2DyiBdo',
  }
};

/**
 * 根据域名后缀获取 Google Site Verification 代码
 * @param host 当前域名
 * @returns Google Site Verification 代码
 */
export const getGoogleSiteVerificationCode = (host: string): string => {
  // 根据域名后缀匹配对应的 verification 代码
  if (host.endsWith('.nl')) {
    return googleSiteVerificationConfig['.nl'].code;
  } else if (host.endsWith('.de')) {
    return googleSiteVerificationConfig['.de'].code;
  } else if (host.endsWith('.fr')) {
    return googleSiteVerificationConfig['.fr'].code;
  } else {
    // 默认返回 .com 的配置
    return googleSiteVerificationConfig['.com'].code;
  }
};

/**
 * 获取所有站点的 Google Site Verification 配置
 * @returns 所有站点的配置信息
 */
export const getAllGoogleVerificationConfigs = (): Record<string, GoogleVerificationConfig> => {
  return googleSiteVerificationConfig;
};
